"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useEffect, useMemo, useRef, useState } from "react";
import { WiStars } from "react-icons/wi";
type ImageGalleryProps = {
  images: {
    url?: string;
    key?: string;
    id?: string;
  }[];
  product?: any;
  videoUrl?: string | null;
  virtualTryOnEnabled?: boolean;
  onVirtualTryOn?: () => void;
};
type GalleryItem = {
  type: "image" | "video";
  url: string;
  key: string;
};
const ImageGallery = t0 => {
  const $ = _c(58);
  const {
    images,
    product,
    videoUrl,
    virtualTryOnEnabled,
    onVirtualTryOn
  } = t0;
  const [selectedImage, setSelectedImage] = useState(0);
  const mobileGalleryRef = useRef(null);
  const showVirtualTryOn = Boolean(virtualTryOnEnabled && typeof onVirtualTryOn === "function");
  let t1;
  bb0: {
    let t2;
    if ($[0] !== images) {
      t2 = Array.isArray(images) ? images.filter(_temp).map(_temp2) : [];
      $[0] = images;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const imageItems = t2;
    if (imageItems.length > 0) {
      t1 = imageItems;
      break bb0;
    }
    if (videoUrl) {
      let t3;
      if ($[2] !== videoUrl) {
        t3 = [{
          type: "video",
          url: videoUrl,
          key: "video"
        }];
        $[2] = videoUrl;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      t1 = t3;
      break bb0;
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = [];
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t1 = t3;
  }
  const galleryItems = t1;
  let t2;
  if ($[5] !== galleryItems.length) {
    t2 = () => {
      const container = mobileGalleryRef.current;
      if (!container || typeof window === "undefined") {
        return;
      }
      let animationFrame = null;
      const handleScroll = () => {
        if (window.innerWidth >= 768) {
          return;
        }
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
        animationFrame = window.requestAnimationFrame(() => {
          const newIndex = Math.round(container.scrollLeft / container.clientWidth);
          const boundedIndex = Math.max(0, Math.min(galleryItems.length - 1, newIndex));
          setSelectedImage(prev => prev === boundedIndex ? prev : boundedIndex);
        });
      };
      container.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => {
        container.removeEventListener("scroll", handleScroll);
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
      };
    };
    $[5] = galleryItems.length;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== images.length) {
    t3 = [images.length];
    $[7] = images.length;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== selectedImage) {
    t4 = () => {
      const container_0 = mobileGalleryRef.current;
      if (!container_0 || typeof window === "undefined") {
        return;
      }
      if (window.innerWidth >= 768) {
        return;
      }
      const targetScrollLeft = selectedImage * container_0.clientWidth;
      if (Math.abs(container_0.scrollLeft - targetScrollLeft) > 1) {
        container_0.scrollTo({
          left: targetScrollLeft,
          behavior: "smooth"
        });
      }
    };
    t5 = [selectedImage];
    $[9] = selectedImage;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  if (galleryItems.length === 0) {
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="w-full h-96 bg-gray-100 rounded-lg flex items-center justify-center"><span className="text-gray-400">No hay imagen disponible</span></div>;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  const progress = galleryItems.length > 0 ? (selectedImage + 1) / galleryItems.length * 100 : 0;
  let t6;
  if ($[13] !== galleryItems || $[14] !== onVirtualTryOn || $[15] !== product || $[16] !== selectedImage || $[17] !== showVirtualTryOn) {
    let t7;
    if ($[19] !== onVirtualTryOn || $[20] !== product || $[21] !== selectedImage || $[22] !== showVirtualTryOn) {
      t7 = (item, index_0) => <div key={item.key} className="relative min-w-full snap-center aspect-[3/4] bg-gray-50">{item.type === "image" ? <Image src={item.url} alt={`Product image ${index_0 + 1}`} fill={true} className="object-cover" sizes="(max-width: 480px) calc(100vw - 24px), (max-width: 767px) calc(100vw - 96px), 0px" priority={index_0 === 0} fetchPriority={index_0 === 0 ? "high" : "auto"} quality={index_0 === 0 ? 70 : 60} /> : <video className="absolute inset-0 h-full w-full object-cover" src={item.url} muted={true} playsInline={true} autoPlay={true} loop={true} />}{product?.discount && <div className="absolute right-4 top-4 flex h-[62px] w-[62px] items-center justify-center bg-lanamara text-[12px] font-semibold uppercase tracking-wide text-white">{product.discount}% OFF</div>}{showVirtualTryOn && index_0 === selectedImage && <div className="absolute inset-x-3 bottom-3"><button type="button" onClick={() => onVirtualTryOn?.()} className="flex w-fit items-center justify-center gap-2 rounded-full bg-black px-6 py-2 text-xs font-lealti-light uppercase tracking-wide text-white shadow-lg backdrop-blur transition hover:bg-black"><WiStars className="h-4 w-4" />Probador Virtual</button></div>}</div>;
      $[19] = onVirtualTryOn;
      $[20] = product;
      $[21] = selectedImage;
      $[22] = showVirtualTryOn;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    t6 = galleryItems.map(t7);
    $[13] = galleryItems;
    $[14] = onVirtualTryOn;
    $[15] = product;
    $[16] = selectedImage;
    $[17] = showVirtualTryOn;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[24] !== t6) {
    t7 = <div ref={mobileGalleryRef} className="flex snap-x snap-mandatory overflow-x-auto no-scrollbar">{t6}</div>;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const t8 = `${progress}%`;
  let t9;
  if ($[26] !== t8) {
    t9 = <div className="relative h-[3px] w-full overflow-hidden bg-black/10"><div className="absolute left-0 top-0 h-full bg-black transition-all duration-300" style={{
        width: t8
      }} /></div>;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = selectedImage + 1;
  let t11;
  if ($[28] !== galleryItems.length || $[29] !== t10) {
    t11 = <div className="text-xs tracking-wide text-right text-black">{t10}/{galleryItems.length}</div>;
    $[28] = galleryItems.length;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t9) {
    t12 = <div className="mt-4 space-y-2">{t9}{t11}</div>;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t7) {
    t13 = <div className="md:hidden"><div className="relative">{t7}{t12}</div></div>;
    $[34] = t12;
    $[35] = t7;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== galleryItems || $[38] !== selectedImage) {
    t14 = galleryItems[selectedImage]?.type === "image" ? <Image src={galleryItems[selectedImage]?.url || ""} priority={selectedImage === 0} className="object-cover" alt={`Product image ${selectedImage + 1}`} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 640px" fetchPriority={selectedImage === 0 ? "high" : "auto"} quality={selectedImage === 0 ? 70 : 60} /> : galleryItems[selectedImage]?.type === "video" ? <video className="h-full w-full object-cover" src={galleryItems[selectedImage]?.url} muted={true} playsInline={true} autoPlay={true} loop={true} /> : null;
    $[37] = galleryItems;
    $[38] = selectedImage;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== product) {
    t15 = product?.discount && <div className="absolute right-4 top-4 flex h-[62px] w-[62px] items-center justify-center bg-lanamara text-[12px] font-semibold uppercase tracking-wide text-white">{product.discount}% OFF</div>;
    $[40] = product;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== onVirtualTryOn || $[43] !== showVirtualTryOn) {
    t16 = showVirtualTryOn && <div className="pointer-events-none absolute inset-x-4 bottom-4"><div className="pointer-events-auto p-2"><button type="button" onClick={() => onVirtualTryOn?.()} className="flex w-fit items-center justify-center gap-1 rounded-3xl bg-black px-5 py-2 text-xs font-lealti-light uppercase tracking-wide text-white transition hover:bg-black/90"><WiStars className="h-6 w-6" />Probador Virtual</button></div></div>;
    $[42] = onVirtualTryOn;
    $[43] = showVirtualTryOn;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t14 || $[46] !== t15 || $[47] !== t16) {
    t17 = <div className="relative aspect-[4/5] w-full overflow-hidden bg-gray-50 h-full min-h-[500px]">{t14}{t15}{t16}</div>;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== galleryItems || $[50] !== selectedImage) {
    t18 = galleryItems.length > 1 && <div className="flex gap-2">{galleryItems.map((item_0, index_1) => <button key={item_0.key} onClick={() => setSelectedImage(index_1)} className={`relative h-24 w-24 overflow-hidden border transition-all ${selectedImage === index_1 ? "border-black" : "border-gray-200"}`}>{item_0.type === "image" ? <Image src={item_0.url} alt={`Product thumbnail ${index_1 + 1}`} fill={true} className="object-cover" sizes="96px" quality={55} /> : <video className="h-full w-full object-cover" src={item_0.url} muted={true} playsInline={true} autoPlay={true} loop={true} />}</button>)}</div>;
    $[49] = galleryItems;
    $[50] = selectedImage;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t17 || $[53] !== t18) {
    t19 = <div className="hidden md:flex md:flex-col md:gap-4">{t17}{t18}</div>;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t13 || $[56] !== t19) {
    t20 = <div className="flex flex-col gap-2 md:gap-4">{t13}{t19}</div>;
    $[55] = t13;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  return t20;
};
export default ImageGallery;
function _temp(image) {
  return Boolean(image?.url);
}
function _temp2(image_0, index) {
  return {
    type: "image" as const,
    url: image_0.url ?? "",
    key: image_0.key || image_0.id || `${index}`
  };
}